/**
 * A PDF, in the app's own viewer, fetched only when a person opens one.
 *
 * The viewer carries pdf.js, which is the largest thing this app would ever ship for a file kind
 * most sessions never open. So it lives behind a dynamic import: this module is a few lines in
 * the documents chunk, and the viewer and its worker are fetched on the first press of a PDF's
 * name. `lazyWithRetry` rather than bare `lazy()` because a tab left open across a deploy asks
 * for a chunk URL that no longer exists, and the retry picks up the new manifest.
 */

import { Suspense } from "react";
import { LoadingPanel } from "@/components/ui/loading-state";
import { lazyWithRetry } from "@/lib/lazy-with-retry";

const PdfViewer = lazyWithRetry(() => import("./pdf-viewer"));

export function PdfPreviewBody({ url, name }: { url: string; name: string }) {
  return (
    <Suspense
      fallback={<LoadingPanel className="h-full min-h-40" data-testid="document-preview-loading" />}
    >
      <PdfViewer url={url} name={name} />
    </Suspense>
  );
}
